<template>
  <div id="concAddress">
    <el-dialog
      v-if="showDialogVisible"
      width="500px"
      :title="dialogTitle"
      :visible.sync="showDialogVisible"
      destroy-on-close
      custom-class="revenue-code-number"
      :before-close="cancel"
    >
      <div class="el-dialog__body-bodys">
        <el-form
          :model="form"
          ref="form"
          label-width="120px"
          class="ccui-form"
          :rules="rules"
        >
          <el-form-item
            v-if="['address'].includes(status)"
            :label="`${addressLabel}：`"
            required
          >
            <!-- 请选择地区 -->
            <el-select
              class="area-select"
              v-model="form.deliveryAreaName"
              placeholder="请选择地区"
              @change="handleChange('deliveryArea')"
            >
              <el-option
                v-for="item in deliveryAreaOptions"
                :key="item.addressCode"
                :label="item.addressAbbr"
                :value="item.addressAbbr"
              >
              </el-option>
            </el-select>
            <!-- 请选择 -->
            <el-select
              class="area-select"
              v-model="form.provinceName"
              placeholder="请选择"
              @change="handleChange('province')"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.addressCode"
                :label="item.addressAbbr"
                :value="item.addressAbbr"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="['address'].includes(status)" label="">
            <!-- 请选择 -->
            <el-select
              class="area-select"
              v-model="form.cityName"
              placeholder="请选择"
              @change="handleChange('city')"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.addressCode"
                :label="item.addressAbbr"
                :value="item.addressAbbr"
              >
              </el-option>
            </el-select>
            <!-- 请选择 -->
            <!-- <el-select
              class="area-select"
              v-model="form.countyName"
              placeholder="请选择"
              @change="handleChange('county')"
            >
              <el-option
                v-for="item in countyOptions"
                :key="item.addressCode"
                :label="item.addressAbbr"
                :value="item.addressAbbr"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="cancel">
          <!-- 取 消 -->
          取 消
        </el-button>
        <el-button size="mini" type="primary-font-mini" @click="confirmSend">
          <!-- 确 定 -->
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { qryAreaAddressLogin } from "@/api/lessor-open-shop.js";
export default {
  name: "concAddress",
  props: {
    addressLabel: {
      type: String,
      default: "主营区域",
    },

    dialogTitle: {
      type: String,
      default: "选择主营区域",
    },
    status: {
      type: String,
      default: "address",
    },
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDialogVisible: false,
      form: {
        deliveryAreaName: "",
        provinceName: "",
        cityName: "",
        countyName: "",
        deliveryPoints: '',
      },
      rules: {
        deliveryAreaName: [
          // 请选择交货地点
          {
            required: true,
            message: "请选择交货地点",
            trigger: "change",
          },
        ],
      },
      deliveryAreaOptions: [],
      provinceOptions: [],
      cityOptions: [],
      countyOptions: [],
      areaArr: ["deliveryArea", "province", "city", "county"],
    };
  },
  created() {},
  methods: {
    init() {
      this.getQryAreaAddress();
      const { areaId, provinceId, cityId } = this.detail;
      this.showDialogVisible = true;
      areaId && this.getQryAreaAddress(areaId);
      provinceId && this.getQryAreaAddress(provinceId, "province");
      cityId && this.getQryAreaAddress(cityId, "city");
      this.form = {
        ...this.detail,
        deliveryAreaName: this.detail.areaName,
        deliveryAreaCode: this.detail.areaId,
        provinceName: this.detail.provinceName,
        province: this.detail.provinceId,
        cityName: this.detail.cityName,
        city: this.detail.cityId,
        countyName: this.detail.countyName,
        county: this.detail.countyId,
      };
    },
    cancel() {
      this.showDialogVisible = false;
      this.$emit("cancesite");
    },

    handleChange(type) {
      const tempCode = this[`${type}Options`].find(
        (_) => _.addressAbbr === this.form[`${type}Name`]
      ).addressCode;

      if (type === "deliveryArea") {
        this.form[`${type}Code`] = tempCode;
        this.form.provinceName = "";
        this.form.cityName = "";
        this.form.countyName = "";
        this.cityOptions = [];
        this.countyOptions = [];
      } else {
        this.form[`${type}`] = tempCode;
      }

      if (type === "province") {
        this.form.cityName = "";
        this.form.countyName = "";
        this.countyOptions = [];
      }
      if (type === "city") this.form.countyName = "";
      if (type !== "county") {
        this.getQryAreaAddress(tempCode, type);
      }

      this.$forceUpdate();
    },

    // 查询区域
    getQryAreaAddress(parentCode = null, branch = "deliveryArea") {
      const data = { parentCode, overseasFlag: 0 };
      qryAreaAddressLogin(data).then((res) => {
        if (res.data.code === "0") {
          if (parentCode == null) {
            this.deliveryAreaOptions = res.data.data.filter(
              (v) => !["970000", "980000"].includes(v.addressCode)
            );
          } else {
            this[
              `${
                this.areaArr[this.areaArr.findIndex((_) => _ === branch) + 1]
              }Options`
            ] = res.data.data;
          }
        }
      });
    },

    // 确定
    handleTrue() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (["address"].includes(this.status)) {
            if (this.form.cityName && this.countyOptions.length === 0) {
              resolve();
            }
            if (
              !this.form.provinceName ||
              !this.form.cityName ||
              !this.form.countyName
            ) {
              // "请选择完整的交货地点"
              return reject("请选择完整的店铺经营地址！");
            }
            // "请填写完整的详细地址"
            if (!this.form.deliveryPoints) return reject('请填写完整的详细地址')
            resolve();
          } else {
            resolve();
          }
        }, 600);
      });
    },

    async confirmSend() {
      try {
        // await this.handleTrue();
        this.$emit("selectMainArea", this.form);
        this.showDialogVisible = false;
        this.$nextTick(() => {
          this.form = {
            deliveryAreaName: "",
            provinceName: "",
            cityName: "",
            countyName: "",
            deliveryPoints: ''
          };
          this.deliveryAreaOptions = [];
          this.provinceOptions = [];
          this.cityOptions = [];
          this.countyOptions = [];
        });
      } catch (error) {
        this.$message.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#concAddress {
  display: inline-block;
  margin-left: 10px;
  // /deep/ .el-dialog__header {
  // display: flex;
  // align-items: center;
  // }
  /deep/ .revenue-code-number .el-dialog__body {
    width: auto;
    height: auto;
  }
  .el-input,
  .el-textarea {
    width: 260px;
  }
  .area-select {
    & + .area-select {
      margin-left: 10px;
    }
    /deep/ .el-input {
      width: 125px;
    }
  }
}
</style>
